import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'


const _hoisted_1 = { class: "text-left no-printable" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]" }, null, -1)
const _hoisted_3 = {
  type: "button",
  class: "btn tw-flex tw-items-center tw-text-[#FFFFFF] tw-bg-[#00A0DA] tw-rounded-[15px] tw-pr-5 tw-pl-5 tw-pt-5 tw-pb-5 mt-3",
  style: {"margin-left":"2rem"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#exampleModalUsers"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_6 = {
  class: "modal fade modal-xl",
  id: "exampleModalUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "modal-dialog" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_12 = { class: "tw-flex tw-gap-3" }
const _hoisted_13 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Name", -1)
const _hoisted_15 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PhoneNumber", -1)
const _hoisted_17 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Date", -1)
const _hoisted_19 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATION DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  class: "modal fade modal-xl",
  id: "exampleModal4858",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel4858",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_34 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_35 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_36 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_37 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SECTION"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCENARIO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH SCENARIO")
  ])
], -1)
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "tw-bg-white tw-rounded-xl tw-p-4 tw-mb-5" }
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<h2 class=\"tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2\"> FIND A </h2><div><div class=\"row\"><div class=\"col-6 d-flex justify-content-start\"><button id=\"openNoteModal1\" class=\"btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm\" style=\"border:none;\" data-bs-toggle=\"modal\" data-bs-target=\"#note-Modal-tc\"> SEE NOTE </button></div><div class=\"col-6 d-flex justify-content-end\"><button id=\"openNoteModal2\" class=\"btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm\" style=\"border:none;\" data-bs-toggle=\"modal\" data-bs-target=\"#note-Modal-inspector\"> SEE NOTE </button></div></div></div><div class=\"modal\" id=\"note-Modal-tc\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-1\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p>The GET IT option updates information to the application being calculated.</p><br><p>The SEND option sends information to the client&#39;s <strong>title company</strong>.</p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose </button></div></div></div></div></div><div class=\"modal\" id=\"note-Modal-inspector\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-2\" data-bs-backdrop=\"static\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p>By clicking on Get it, will show you the existing inspection services from which you must choose the required service. <br><br> Then you will press the option next and it will show you the <strong>inspectors</strong> who provide those services, you will choose one and click next.<br><br> It will show you the information that you must fill out about the client and with the option send now, the information will be sent to the inspector who will contact the client. </p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose </button></div></div></div></div></div>", 4)
const _hoisted_51 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_52 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExampleBudgetTittle",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("TITLE COMPANY ")
], -1)
const _hoisted_54 = {
  class: "collapse",
  id: "collapseExampleBudgetTittle"
}
const _hoisted_55 = { class: "card card-body" }
const _hoisted_56 = { class: "tw-flex tw-justify-around" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample6",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("INSPECTOR ")
], -1)
const _hoisted_61 = {
  class: "collapse",
  id: "collapseExample6"
}
const _hoisted_62 = { class: "card card-body" }
const _hoisted_63 = { class: "tw-flex tw-justify-around" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]" }, " GET IT ", -1)
const _hoisted_66 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, " BUDGET ", -1)
const _hoisted_68 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " MORTGAGE LOAN ORIGINATOR ", -1)
const _hoisted_70 = { class: "tw-px-4" }
const _hoisted_71 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_72 = { class: "tw-w-full" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROPERTY", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROPERTY", -1)
const _hoisted_75 = ["value"]
const _hoisted_76 = { class: "tw-w-full" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "SCORE CREDIT", -1)
const _hoisted_78 = { class: "tw-w-full" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROGRAM", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROGRAM", -1)
const _hoisted_81 = ["value"]
const _hoisted_82 = { class: "tw-w-full" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "YEARS", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT YEAR", -1)
const _hoisted_85 = ["value"]
const _hoisted_86 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-5" }
const _hoisted_87 = { class: "tw-mt-4 tw-mb-12" }
const _hoisted_88 = { class: "tw-w-full table-edit" }
const _hoisted_89 = ["colspan"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center tw-text-white tw-text-base tw-py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-[13px]" }, "PERSONAL DATA")
], -1)
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " NAME ", -1)
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PHONE NUMBER ", -1)
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " EMAIL ", -1)
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_103 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_104 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTERES RATE ", -1)
const _hoisted_106 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MINIMUM DOWN PAYMENT ", -1)
const _hoisted_108 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI ", -1)
const _hoisted_110 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BACK END RATIO DTI ", -1)
const _hoisted_112 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MAXIMUM LOAN NOT JUMBO ", -1)
const _hoisted_114 = { class: "tw-w-full table-edit tw-shadow-none tw-border-none tw-mt-2" }
const _hoisted_115 = { class: "tw-[&>td]:border-r-0" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("td", { class: "tw-border-none" }, null, -1)
const _hoisted_117 = ["onClick"]
const _hoisted_118 = { class: "tw-[&>td]:border-r-0" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("td", { class: "tw-border-none" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "d-block tw-mt-5" }, "Send information")
], -1)
const _hoisted_120 = ["onClick"]
const _hoisted_121 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden tw-pb-[30px]" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " CUSTOMER ", -1)
const _hoisted_123 = { class: "tw-px-4" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-border tw-border-b-[#545454] tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-pb-1 tw-mt-7 tw-text-left" }, " PERSONAL DATA ", -1)
const _hoisted_125 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_126 = { class: "tw-w-full" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_128 = { class: "tw-w-full" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_130 = { class: "tw-w-full" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)
const _hoisted_132 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " FINANCING INFORMATION ", -1)
const _hoisted_134 = { class: "tw-px-4" }
const _hoisted_135 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_136 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY BUDGET PAYMENT ", -1)
const _hoisted_138 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_139 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE ", -1)
const _hoisted_141 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_142 = { class: "tw-flex tw-items-center tw-relative tw-py-3" }
const _hoisted_143 = { class: "tw-flex tw-items-center tw-w-full" }
const _hoisted_144 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOWN PAYMENT ", -1)
const _hoisted_146 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_147 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE ", -1)
const _hoisted_149 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_150 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN YEARS ", -1)
const _hoisted_152 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_153 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " SORT OUT ", -1)
const _hoisted_155 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_156 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN AMOUNT ", -1)
const _hoisted_158 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_159 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY PAYMENT ", -1)
const _hoisted_161 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_162 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN PROGRAM ", -1)
const _hoisted_164 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_165 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI ", -1)
const _hoisted_167 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_168 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES ", -1)
const _hoisted_170 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_171 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAX ", -1)
const _hoisted_173 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_174 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE ", -1)
const _hoisted_176 = { class: "tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_177 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION ", -1)
const _hoisted_179 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_180 = { class: "tw-flex tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-justify-center" }
const _hoisted_181 = { class: "tw-flex tw-justify-center" }
const _hoisted_182 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_183 = { class: "tw-flex tw-justify-end tw-gap-[50px]" }
const _hoisted_184 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " ESTIMATE MORTGAGE ", -1)
const _hoisted_186 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " TOTAL MONTHLY ", -1)
const _hoisted_188 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }
const _hoisted_189 = ["disabled"]
const _hoisted_190 = {
  class: "modal fade modal-xl",
  id: "exampleModalEscenario1",
  tabindex: "-1",
  "aria-labelledby": "exampleModalEscenario1",
  "aria-hidden": "true"
}
const _hoisted_191 = { class: "modal-dialog" }
const _hoisted_192 = { class: "modal-content" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_194 = { class: "modal-body" }
const _hoisted_195 = { class: "tw-flex tw-justify-end tw-gap-[40px] tw-pr-7" }
const _hoisted_196 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_197 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print tw-text-[#FFFFFF] tw-pr-2" }, null, -1)
const _hoisted_198 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#FFFFFF] tw-text-[18px] tw-pr-2" }, null, -1)
const _hoisted_200 = {
  class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-",
  id: "printable-target"
}
const _hoisted_201 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_202 = {
  key: 0,
  class: "tw-flex tw-justify-start gap-3 tw-w-full"
}
const _hoisted_203 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_204 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, " MORTGAGE LOAN ORIGINATOR ")
  ])
], -1)
const _hoisted_206 = { class: "data" }
const _hoisted_207 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY", -1)
const _hoisted_208 = { class: "data" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("td", null, "SCORE-CREDIT", -1)
const _hoisted_210 = { class: "data" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("td", null, "PROGRAM", -1)
const _hoisted_212 = { class: "data" }
const _hoisted_213 = /*#__PURE__*/_createElementVNode("td", null, "YEARS", -1)
const _hoisted_214 = { class: "data" }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("td", null, "NAME-MLO", -1)
const _hoisted_216 = { class: "data" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER-MLO", -1)
const _hoisted_218 = { class: "data" }
const _hoisted_219 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL-MLO", -1)
const _hoisted_220 = { class: "data" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("td", null, "PROGRAM-MLO", -1)
const _hoisted_222 = { class: "data" }
const _hoisted_223 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_224 = { class: "data" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-LOWER", -1)
const _hoisted_226 = { class: "data" }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-HIGHER", -1)
const _hoisted_228 = { class: "data" }
const _hoisted_229 = /*#__PURE__*/_createElementVNode("td", null, "AVERAGE-PMI", -1)
const _hoisted_230 = { class: "data" }
const _hoisted_231 = /*#__PURE__*/_createElementVNode("td", null, "BACK-END-RATIO-DTI", -1)
const _hoisted_232 = { class: "data" }
const _hoisted_233 = /*#__PURE__*/_createElementVNode("td", null, "MAXIMUM-LOAN-NOT-JUMBO", -1)
const _hoisted_234 = { class: "table table-bordered border-0 mb-3 table-edit mt-3" }
const _hoisted_235 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CUSTOMER INFORMATION")
  ])
], -1)
const _hoisted_236 = { class: "data" }
const _hoisted_237 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_238 = { class: "data" }
const _hoisted_239 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER", -1)
const _hoisted_240 = { class: "data" }
const _hoisted_241 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL", -1)
const _hoisted_242 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_243 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FINANCIAL-INFORMATION")
  ])
], -1)
const _hoisted_244 = { class: "data" }
const _hoisted_245 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-BUDGET-PAYMENT", -1)
const _hoisted_246 = { class: "data" }
const _hoisted_247 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-PRICE", -1)
const _hoisted_248 = { class: "data" }
const _hoisted_249 = /*#__PURE__*/_createElementVNode("td", null, "DOWN-PAYMENT", -1)
const _hoisted_250 = { class: "data" }
const _hoisted_251 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_252 = { class: "data" }
const _hoisted_253 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-YEARS", -1)
const _hoisted_254 = { class: "data" }
const _hoisted_255 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-PROGRAM", -1)
const _hoisted_256 = { class: "data" }
const _hoisted_257 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-AMOUNT", -1)
const _hoisted_258 = { class: "data" }
const _hoisted_259 = /*#__PURE__*/_createElementVNode("td", null, "PMI-OR-MIP", -1)
const _hoisted_260 = { class: "data" }
const _hoisted_261 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-TAXES", -1)
const _hoisted_262 = { class: "data" }
const _hoisted_263 = /*#__PURE__*/_createElementVNode("td", null, "FEDERAL-TAXES", -1)
const _hoisted_264 = { class: "data" }
const _hoisted_265 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-INSURANCE", -1)
const _hoisted_266 = { class: "data" }
const _hoisted_267 = /*#__PURE__*/_createElementVNode("td", null, "ASSOCIATION", -1)
const _hoisted_268 = /*#__PURE__*/_createElementVNode("tr", { class: "data" }, [
  /*#__PURE__*/_createElementVNode("td", null, "ESTIMATE-MORGAGE"),
  /*#__PURE__*/_createElementVNode("td", null, "0")
], -1)
const _hoisted_269 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_270 = { class: "modal-dialog" }
const _hoisted_271 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_272 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, " New Message "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_273 = { class: "modal-body" }
const _hoisted_274 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_275 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_276 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_277 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_278 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_279 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_280 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_281 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_282 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_283 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_284 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_285 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_loading = _resolveComponent("loading")!
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_TopBar, {
      helpBar: true,
      helpDescription: "Video tutorial for the use of the ''BUDGET''",
      helpVideo: "https://www.realtortools.org/media/Video-Budget.mp4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["tw-fixed tw-top-0 tw-left-0", { 'tw-w-full tw-h-full': _ctx.loaderConfig.isLoading }])
      }, [
        _createVNode(_component_loading, {
          active: _ctx.loaderConfig.isLoading,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
          "can-cancel": false,
          loader: 'dots',
          "is-full-page": !_ctx.loaderConfig.fullPage
        }, null, 8, ["active", "is-full-page"])
      ], 2),
      _createElementVNode("div", null, [
        _createVNode(_component_ResidentialView, {
          header: false,
          onRealtorEvent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeRealtor($event)))
        })
      ]),
      _hoisted_2,
      _createElementVNode("button", _hoisted_3, [
        _createElementVNode("img", {
          class: "tw-w-[40px] tw-mr-3",
          src: require('@/assets/Images/iconos-02.png'),
          alt: ""
        }, null, 8, _hoisted_4),
        _createTextVNode(" RECORD ")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_ctx.scenario.users)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _withDirectives(_createElementVNode("input", {
                            name: "",
                            id: "",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.scenario.users.name) = $event)),
                            class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                          }, null, 512), [
                            [_vModelText, _ctx.params.scenario.users.name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _withDirectives(_createElementVNode("input", {
                            name: "",
                            id: "",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.scenario.users.phonenumber) = $event)),
                            class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                          }, null, 512), [
                            [_vModelText, _ctx.params.scenario.users.phonenumber]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_datepicker, {
                            "auto-apply": "",
                            class: "w-100",
                            range: "",
                            modelValue: _ctx.configDatePicker.date,
                            "onUpdate:modelValue": [
                              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                              _ctx.changeDate
                            ],
                            placeholder: "Enter date range..."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getScenarioUsers())),
                        class: "mb-3 tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]"
                      }, " Filter "),
                      _createElementVNode("table", _hoisted_19, [
                        _hoisted_20,
                        (_ctx.scenario.users.results.length > 0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.users.results, (user, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", null, _toDisplayString(user.user_name), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.user_email), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.user_phonenumber), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.create_date), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#exampleModal4858",
                                      href: "#",
                                      onClick: ($event: any) => (_ctx.loadScenarios(user))
                                    }, _hoisted_24, 8, _hoisted_22)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("tbody", _hoisted_25, _hoisted_27))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      (_ctx.scenario.userScenarios)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("table", _hoisted_37, [
                              _hoisted_38,
                              (
                            _ctx.scenario.userScenarios.results &&
                            _ctx.scenario.userScenarios.results.length > 0
                          )
                                ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario
                              .userScenarios.results, (userscenario, index) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                        _createElementVNode("td", null, _toDisplayString(userscenario.date), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.type), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.type_name), 1),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("a", {
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#exampleModalEscenario1",
                                            href: "#",
                                            onClick: ($event: any) => (_ctx.loadScenario(userscenario))
                                          }, _hoisted_42, 8, _hoisted_40)
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("tbody", _hoisted_43, _hoisted_45))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitleCompanies, (user, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("span", null, _toDisplayString(user.companyname), 1),
                        _createTextVNode(),
                        _hoisted_57,
                        _createElementVNode("button", {
                          class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                          onClick: ($event: any) => (_ctx.getItTitleCompany(user))
                        }, " GET IT ", 8, _hoisted_58)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("span", null, _toDisplayString(user.username + " " + user.lastname), 1),
                        _hoisted_64,
                        _hoisted_65
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _withDirectives(_createElementVNode("select", {
                    name: "",
                    id: "",
                    class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.property) = $event))
                  }, [
                    _hoisted_74,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTableProperties, (tabletype) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: tabletype.id,
                        key: tabletype.id
                      }, _toDisplayString(tabletype.name), 9, _hoisted_75))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.property]
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.score) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.filters.score]
                  ])
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _withDirectives(_createElementVNode("select", {
                    name: "",
                    id: "",
                    class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.program) = $event))
                  }, [
                    _hoisted_80,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPrograms, (program) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: program.id,
                        key: program.id
                      }, _toDisplayString(program.name), 9, _hoisted_81))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.program]
                  ])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _withDirectives(_createElementVNode("select", {
                    name: "",
                    id: "",
                    class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.year) = $event))
                  }, [
                    _hoisted_84,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listYears, (year) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: year.id,
                        key: year.id
                      }, _toDisplayString(year.name), 9, _hoisted_85))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.year]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("button", {
                  class: "tw-bg-[#00a0da] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[200px]",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.filterTable && _ctx.filterTable(...args)))
                }, " RUN ")
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("table", _hoisted_88, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "tw-bg-[#00a0da] tw-rounded-tl-2xl tw-rounded-tr-2xl",
                        colspan: _ctx.listUserSections.length + 1
                      }, _hoisted_91, 8, _hoisted_89)
                    ])
                  ]),
                  (_ctx.listUserSections.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_92, [
                        _createElementVNode("tr", _hoisted_93, [
                          _hoisted_94,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              key: index
                            }, [
                              (_ctx.filters.active)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_95, _toDisplayString(user.username + " " + user.lastname), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("tr", _hoisted_96, [
                          _hoisted_97,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              key: index
                            }, [
                              (_ctx.filters.active)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(user.phonenumber), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("tr", _hoisted_99, [
                          _hoisted_100,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              key: index
                            }, [
                              (_ctx.filters.active)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(user.email), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("tr", _hoisted_102, [
                          _createElementVNode("td", _hoisted_103, _toDisplayString(_ctx.filters.program_name), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              key: index
                            }, _toDisplayString(user.fha), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", _hoisted_104, [
                          _hoisted_105,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              key: index
                            }, _toDisplayString(user.interes_rate), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", _hoisted_106, [
                          _hoisted_107,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              key: index
                            }, _toDisplayString(user.minimum_down_payment &&
                        user.minimum_down_payment != "-"
                        ? user.minimum_down_payment + "%"
                        : "-"), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", _hoisted_108, [
                          _hoisted_109,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              key: index
                            }, _toDisplayString(user.average_mip_pmi), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", _hoisted_110, [
                          _hoisted_111,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              key: index
                            }, _toDisplayString(user.backend_ratio), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", _hoisted_112, [
                          _hoisted_113,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              key: index
                            }, _toDisplayString(user.maximum_loan
                        ? "" + _ctx.commaFormat(user.maximum_loan)
                        : ""), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("table", _hoisted_114, [
                  _createElementVNode("tr", _hoisted_115, [
                    _hoisted_116,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        class: "tw-border-none tw-px-4",
                        key: index
                      }, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.loadData(user)),
                          class: "tw-bg-[#00a0da] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-mt-5"
                        }, " GET IT ", 8, _hoisted_117)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("tr", _hoisted_118, [
                    _hoisted_119,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        class: "tw-border-none tw-px-4",
                        key: index
                      }, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.sendData(user)),
                          class: "tw-bg-[#00a0da] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-mt-5"
                        }, " SEND ", 8, _hoisted_120)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_121, [
            _hoisted_122,
            _createElementVNode("div", _hoisted_123, [
              _hoisted_124,
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  _hoisted_127,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customer.name) = $event)),
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_128, [
                  _hoisted_129,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customer.phone) = $event)),
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_130, [
                  _hoisted_131,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customer.email) = $event)),
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.email]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_132, [
            _hoisted_133,
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("table", _hoisted_135, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_136, [
                    _hoisted_137,
                    _createElementVNode("td", _hoisted_138, [
                      _createVNode(_component_VueNumberFormat, {
                        value: _ctx.financialInformation.monthlyBudget,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.financialInformation.monthlyBudget) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: false,
                        isInteger: true,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_139, [
                    _hoisted_140,
                    _createElementVNode("td", _hoisted_141, [
                      _createElementVNode("div", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, [
                          _createVNode(_component_VueNumberFormat, {
                            id: "propertyPriceBudget",
                            onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.calculateField('estimatemortgage'))),
                            class: "tw-w-full",
                            value: _ctx.propertyPrice,
                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.propertyPrice) = $event)),
                            options: {
                              precision: 0,
                              prefix: '$ ',
                              thousand: ',',
                              acceptNegative: true,
                              isInteger: false,
                              decimal: '.',
                            }
                          }, null, 8, ["value", "options"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_144, [
                    _hoisted_145,
                    _createElementVNode("td", _hoisted_146, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "downPaymentBudget",
                        onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.calculateField('estimatemortgage'))),
                        value: _ctx.financialInformation.downPayment,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.financialInformation.downPayment) = $event)),
                        options: {
                          precision: 0,
                          prefix: '$ ',
                          thousand: ',',
                          acceptNegative: false,
                          isInteger: true,
                          decimal: '.',
                        }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_147, [
                    _hoisted_148,
                    _createElementVNode("td", _hoisted_149, _toDisplayString(_ctx.selection.selectedUser
                      ? _ctx.selection.selectedUser.interes_rate
                      : ""), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_150, [
                    _hoisted_151,
                    _createElementVNode("td", _hoisted_152, _toDisplayString(_ctx.selection.selectedYears
                      ? _ctx.selection.selectedYears.name
                      : ""), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_153, [
                    _hoisted_154,
                    _createElementVNode("td", _hoisted_155, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "sortOut",
                        value: _ctx.financialInformation.sortOut,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.financialInformation.sortOut) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: true,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_156, [
                    _hoisted_157,
                    _createElementVNode("td", _hoisted_158, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "estimatemortgage",
                        readonly: "",
                        value: _ctx.loanAmount,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.loanAmount) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_159, [
                    _hoisted_160,
                    _createElementVNode("td", _hoisted_161, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.monthlyPayment,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.monthlyPayment) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_162, [
                    _hoisted_163,
                    _createElementVNode("td", _hoisted_164, _toDisplayString(_ctx.selection.selectedProgram
                      ? _ctx.selection.selectedProgram.name
                      : ""), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_165, [
                    _hoisted_166,
                    _createElementVNode("td", _hoisted_167, " $ " + _toDisplayString(_ctx.pmi !== null ? Math.round(_ctx.pmi).toLocaleString() : ""), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_168, [
                    _hoisted_169,
                    _createElementVNode("td", _hoisted_170, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.propertyTaxes,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.propertyTaxes) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_171, [
                    _hoisted_172,
                    _createElementVNode("td", _hoisted_173, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.federalTaxes,
                        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.federalTaxes) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_174, [
                    _hoisted_175,
                    _createElementVNode("td", _hoisted_176, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.propertyInsurance,
                        "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.propertyInsurance) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: true,
                        isInteger: false,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_177, [
                    _hoisted_178,
                    _createElementVNode("td", _hoisted_179, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "association",
                        value: _ctx.financialInformation.association,
                        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.financialInformation.association) = $event)),
                        options: {
                        precision: 0,
                        prefix: '$ ',
                        thousand: ',',
                        acceptNegative: false,
                        isInteger: true,
                        decimal: '.',
                      }
                      }, null, 8, ["value", "options"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_180, [
            _createElementVNode("button", {
              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.submitFormula('propertyTotalExample', $event))),
              class: "tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl disabled:tw-bg-[#cfcfcf] disabled:tw-text-white"
            }, " DONE ")
          ]),
          _createElementVNode("div", _hoisted_181, [
            _createElementVNode("div", _hoisted_182, [
              _createElementVNode("div", _hoisted_183, [
                _createElementVNode("div", _hoisted_184, [
                  _hoisted_185,
                  _createVNode(_component_VueNumberFormat, {
                    id: "association",
                    value: _ctx.loanAmount,
                    "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.loanAmount) = $event)),
                    options: {
                    precision: 0,
                    prefix: '$ ',
                    thousand: ',',
                    acceptNegative: false,
                    isInteger: false,
                    decimal: '.',
                  },
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                  }, null, 8, ["value", "options"])
                ]),
                _createElementVNode("div", _hoisted_186, [
                  _hoisted_187,
                  _createVNode(_component_VueNumberFormat, {
                    id: "association",
                    value: _ctx.totalMonthly,
                    "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.totalMonthly) = $event)),
                    options: {
                    precision: 0,
                    prefix: '$ ',
                    thousand: ',',
                    acceptNegative: false,
                    isInteger: false,
                    decimal: '.',
                  },
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                  }, null, 8, ["value", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_188, [
            _createElementVNode("button", {
              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.submitScenario($event))),
              disabled: !_ctx.scenarioValid,
              class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
            }, " SAVE & REGISTER ", 8, _hoisted_189)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_190, [
      _createElementVNode("div", _hoisted_191, [
        _createElementVNode("div", _hoisted_192, [
          _hoisted_193,
          _createElementVNode("div", _hoisted_194, [
            _createElementVNode("div", _hoisted_195, [
              _createElementVNode("div", _hoisted_196, [
                _createElementVNode("button", {
                  onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.printScenario())),
                  class: "block"
                }, [
                  _hoisted_197,
                  _createTextVNode("PRINT ")
                ])
              ]),
              _createElementVNode("div", _hoisted_198, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.generateMail()))
                }, [
                  _hoisted_199,
                  _createTextVNode("SEND")
                ]),
                _createVNode(_component_vue3_html2pdf, {
                  "show-layout": false,
                  "float-layout": true,
                  "enable-download": false,
                  "preview-modal": false,
                  "pdf-quality": 2,
                  "pdf-format": "a4",
                  "pdf-content-width": "800px",
                  "manual-pagination": true,
                  onBeforeDownload: _cache[32] || (_cache[32] = ($event: any) => (_ctx.beforeFileGenerated($event))),
                  ref: "html2Pdf"
                }, {
                  "pdf-content": _withCtx(() => []),
                  _: 1
                }, 512)
              ])
            ]),
            _createElementVNode("div", _hoisted_200, [
              _createElementVNode("div", _hoisted_201, [
                (_ctx.scenario.scenarioData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                      _createElementVNode("div", _hoisted_203, [
                        _createElementVNode("table", _hoisted_204, [
                          _hoisted_205,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_206, [
                              _hoisted_207,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .property), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_208, [
                              _hoisted_209,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .scoreCreditMlos), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_210, [
                              _hoisted_211,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .programMlos), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_212, [
                              _hoisted_213,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.years), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_214, [
                              _hoisted_215,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .nameMlo), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_216, [
                              _hoisted_217,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .phoneMlo), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_218, [
                              _hoisted_219,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .emailMlo), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_220, [
                              _hoisted_221,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .programMlos), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_222, [
                              _hoisted_223,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser
                            .interes_rate), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_224, [
                              _hoisted_225,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data?.selectedUser
                            .minimum_down_paymentlower), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_226, [
                              _hoisted_227,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data?.selectedUser
                            .minimum_down_paymenthigher), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_228, [
                              _hoisted_229,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data?.selectedUser
                            .average_mip_pmi), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_230, [
                              _hoisted_231,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data?.selectedUser
                            .backend_ratio), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_232, [
                              _hoisted_233,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data?.selectedUser
                            .maximum_loan), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_234, [
                          _hoisted_235,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_236, [
                              _hoisted_237,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_238, [
                              _hoisted_239,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_phonenumber), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_240, [
                              _hoisted_241,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_email), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_242, [
                          _hoisted_243,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_244, [
                              _hoisted_245,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .monthlyBudgetPayment), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_246, [
                              _hoisted_247,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .propertyPrice), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_248, [
                              _hoisted_249,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .downPayment), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_250, [
                              _hoisted_251,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .interestRate) + "% ", 1)
                            ]),
                            _createElementVNode("tr", _hoisted_252, [
                              _hoisted_253,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedYears
                            .name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_254, [
                              _hoisted_255,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data
                            .selectedProgram.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_256, [
                              _hoisted_257,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .estimateMortgage), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_258, [
                              _hoisted_259,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser
                            .average_mip_pmi), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_260, [
                              _hoisted_261,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .propertyTaxes), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_262, [
                              _hoisted_263,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .stateTaxes), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_264, [
                              _hoisted_265,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .propertyInsurance), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_266, [
                              _hoisted_267,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information
                            .association), 1)
                            ]),
                            _hoisted_268
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_269, [
      _createElementVNode("div", _hoisted_270, [
        _createElementVNode("div", _hoisted_271, [
          _hoisted_272,
          _createElementVNode("div", _hoisted_273, [
            _createElementVNode("div", _hoisted_274, [
              _hoisted_275,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_276, [
              _hoisted_277,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.subject]
              ])
            ]),
            _createElementVNode("div", _hoisted_278, [
              _withDirectives(_createElementVNode("textarea", {
                name: "",
                id: "",
                cols: "53",
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                rows: "9"
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.message]
              ])
            ])
          ]),
          _hoisted_279,
          _createElementVNode("div", _hoisted_280, [
            _createElementVNode("div", _hoisted_281, [
              (_ctx.scenarioMail.file)
                ? (_openBlock(), _createElementBlock("button", _hoisted_282, [
                    _hoisted_283,
                    _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_284, [
              _createElementVNode("button", {
                "data-bs-dismiss": "modal",
                class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                disabled: _ctx.v$.scenarioMail.$invalid,
                onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
              }, " SEND MESSAGE ", 8, _hoisted_285)
            ])
          ])
        ])
      ])
    ])
  ]))
}